import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/PageHeader';
import { IssueForm } from '@/features/issues/components/IssueForm';

export function IssueSubmitPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/issues">
            <ArrowLeft className="h-4 w-4" />
            Back to issues
          </Link>
        </Button>
      </div>
      <PageHeader
        title="Submit an issue"
        subtitle="Raptor staff will see this and follow up via the Conversation thread."
      />
      <Card>
        <CardContent className="pt-6">
          <IssueForm />
        </CardContent>
      </Card>
    </div>
  );
}
